import { Amplify } from 'aws-amplify';

if (!import.meta.env.VITE_COGNITO_USER_POOL_ID || !import.meta.env.VITE_COGNITO_CLIENT_ID) {
  throw new Error(
    'Missing required environment variables: VITE_COGNITO_USER_POOL_ID and VITE_COGNITO_CLIENT_ID must be set'
  );
}

const cognitoDomain = import.meta.env.VITE_COGNITO_DOMAIN;
const region = import.meta.env.VITE_AWS_REGION || 'us-east-1';
const environment = import.meta.env.VITE_ENVIRONMENT || 'dev';

// Build redirect URLs matching Cognito configuration
const buildRedirectUrls = () => {
  const currentOrigin = window.location.origin;
  const urls: string[] = [];

  // Development environment URLs
  if (environment === 'dev') {
    // For CloudFront: https://dev-media-magic.umangshah.me/dev/
    if (currentOrigin === 'https://dev-media-magic.umangshah.me') {
      urls.push(`${currentOrigin}/dev/`);
    }
    // For localhost dev servers
    else if (currentOrigin.includes('localhost')) {
      if (currentOrigin.includes('5173')) {
        urls.push('http://localhost:5173');
      } else {
        urls.push('http://localhost:3000');
      }
      // Also add /dev/ variant for dev server
      urls.push(`${currentOrigin}/dev/`);
    }
  }
  // Production environment URLs
  else {
    // For CloudFront: https://media-magic.umangshah.me
    if (currentOrigin.includes('media-magic.umangshah.me')) {
      urls.push(currentOrigin);
    }
    // Fallback
    else {
      urls.push(currentOrigin);
    }
  }

  return urls;
};

const awsConfig = {
  Auth: {
    Cognito: {
      userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID,
      userPoolClientId: import.meta.env.VITE_COGNITO_CLIENT_ID,
      ...(cognitoDomain && {
        loginWith: {
          oauth: {
            domain: `${cognitoDomain}.auth.${region}.amazoncognito.com`,
            scopes: ['openid', 'email', 'profile'],
            redirectSignIn: buildRedirectUrls(),
            redirectSignOut: buildRedirectUrls(),
            responseType: 'code' as const,
          },
        },
      }),
    },
  },
};

export function configureAuth() {
  Amplify.configure(awsConfig);
}

export default awsConfig;
